import agent from '../agent';
import {
    POLLY_COMMENTS_LOADED,
    POLLY_COMMENTS_LOADING,
    RELATED_POLLY_LOADING,
    RELATED_POLLY_LOADED,
    POLLY_ADD_COMMENTS,
    PARTY_COMMENTS_LOADED,
    POLLY_NEWS_LOADED,
    POLLY_COMMENTS_USER_INFO_LOAD,
    RELATED_PARTY_LOADED,
    RELATED_PARTY_LOADING,
    PARTY_COMMENTS_LOADING,
} from '../constants/actionTypes';

export const fetchPollyCommentsStart = () => ({
    type: POLLY_COMMENTS_LOADING,
})

export const fetchPollyCommentsFinished = (payload) => ({
    type: POLLY_COMMENTS_LOADED,
    payload
})

export const setCommentUserInfo = (payload) => ({
    type: POLLY_COMMENTS_USER_INFO_LOAD,
    payload
})

export const fetchPollyNewsFinished = (payload) => ({
    type: POLLY_NEWS_LOADED,
    payload
})

export const fetchNewsList = (dispatch) => (person) => {
    agent.Pollies.searchForTag(person).then(res => {
        if(res && res.length > 0) {
            let tags = []
            res.forEach(tag => {
                tags.push(tag.id)
            })
            tags = tags.join(',')
            agent.Pollies.getNewsList(tags).then(news=> {
                if(news) {
                    dispatch(fetchPollyNewsFinished(news));
                }
            })
        }
    })
};

export const commentsUserInfoLoad = (commentList, getState, dispatch) => {
    let users = []
    let store = getState();
    let currentUsers = store.commentList && store.commentList.userInfo || {}
    commentList && commentList.forEach(comment => {
        users.push(comment.authorId)
    })
    users = users.filter((value, index, self) => {
        return self.indexOf(value) === index;
    })
    users = users.filter(value=> !currentUsers[value])
    users = users.join(',')
    if (users) {
        agent.Pollies.getCommentsUserInfoList(users).then(res=> {
            const userInfos = {}
            if(res) {
                res.forEach(user=> {
                    userInfos[user.id] = user
                })
                dispatch(setCommentUserInfo(userInfos))
            }
        })
    }
}

export const fetchPollyCommentList = (dispatch, getState) => (personID) => {
    dispatch(fetchPollyCommentsStart());
    agent.Pollies.getComments(personID).then(res => {
        commentsUserInfoLoad(res, getState, dispatch);
        dispatch(fetchPollyCommentsFinished(res));
    }, err => {
        dispatch(fetchPollyCommentsFinished(err));
    })
};


export const fetchRelatedPollyStart = () => ({
    type: RELATED_POLLY_LOADING,
})

export const fetchRelatedPollyFinished = (payload) => ({
    type: RELATED_POLLY_LOADED,
    payload
})

export const fetchRelatedPollicies = (dispatch) => (personID) => {
    dispatch(fetchRelatedPollyStart());
    agent.Pollies.getRelatedPollicies(personID).then(res => {
        dispatch(fetchRelatedPollyFinished(res));
    }, err => {
        dispatch(fetchRelatedPollyFinished(err));
    })
};

export const addComments = (dispatch, getState) => (personID, body) => {
    agent.Pollies.addComment(personID, body).then(res => {
        agent.Pollies.getComments(personID).then(res1 => {
            commentsUserInfoLoad(res1, getState, dispatch);
            dispatch(fetchPollyCommentsFinished(res1));
        }, err => {
            dispatch(fetchPollyCommentsFinished(err));
        })
    })
};

/* ----------------add party comment --------------*/
export const fetchPartyCommentsStart = () => ({
    type: PARTY_COMMENTS_LOADING,
})


export const fetchRelatedPartyFinished = (payload) => ({
    type: RELATED_PARTY_LOADED,
    payload
})

export const fetchPartyCommentsFinished = (payload) => ({
    type: PARTY_COMMENTS_LOADED,
    payload
})

export const fetchPartyCommentList = (dispatch, getState) => (personID) => {
    dispatch(fetchPartyCommentsStart());
    agent.Pollies.getPartyComments(personID).then(res => {
        commentsUserInfoLoad(res, getState, dispatch);
        dispatch(fetchPartyCommentsFinished(res));
    }, err => {
        dispatch(fetchPartyCommentsFinished(err));
    })
};

export const addPartyComments = (dispatch, getState) => (partyId, body) => {
    agent.Pollies.addPartyComments(partyId, body).then(res => {
        agent.Pollies.getPartyComments(partyId).then(res1 => {
            commentsUserInfoLoad(res1, getState, dispatch);
            dispatch(fetchPartyCommentsFinished(res1));
        }, err => {
            dispatch(fetchPollyCommentsFinished(err));
        })
    })
};

export const fetchRelatedPartyStart = () => ({
    type: RELATED_PARTY_LOADING,
})

export const fetchRelatedParty = (dispatch) => (personID) => {
    dispatch(fetchRelatedPartyStart());
    agent.Pollies.getRelatedParty(personID).then(res => {
        dispatch(fetchRelatedPartyFinished(res));
    }, err => {
        dispatch(fetchRelatedPartyFinished(err));
    })
};

/* ----------------end party comment --------------*/